/**
 * Иконки нижнего меню — инлайн-SVG вместо статичных файлов из /icons:
 * статичный <img> нельзя перекрасить, а здесь активная вкладка загорается
 * аврора-градиентом (тем же, что полоска под пунктом), неактивная — приглушённый
 * контур. Штрих 1.9/round у всех пяти — комплект выглядит единым.
 */

/** Общий градиент: один <defs> на всё меню, иконки ссылаются по url(#nav-grad). */
export function NavIconDefs() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <defs>
        <linearGradient id="nav-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="var(--aurora-teal)" />
          <stop offset="0.55" stopColor="var(--aurora-violet)" />
          <stop offset="1" stopColor="var(--aurora-pink)" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function frame(active: boolean) {
  return {
    viewBox: '0 0 24 24',
    width: 24,
    height: 24,
    fill: 'none',
    // активная — фиолетовый акцент (единственный цветной элемент меню), остальные — пепельный контур
    stroke: active ? '#8a5cff' : 'currentColor',
    strokeWidth: 1.9,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  } as const;
}

export function HomeIcon({ active }: { active: boolean }) {
  return (
    <svg {...frame(active)}>
      <path d="M4 11.2 12 4.5l8 6.7" />
      <path d="M5.8 10v8.6a1.4 1.4 0 0 0 1.4 1.4h9.6a1.4 1.4 0 0 0 1.4-1.4V10" />
      <path d="M9.8 20v-4.9a2.2 2.2 0 0 1 4.4 0V20" />
    </svg>
  );
}

/** Trade — свечной график: три свечи с фитилями. */
export function TradeIcon({ active }: { active: boolean }) {
  return (
    <svg {...frame(active)}>
      <rect x="3.4" y="10" width="4" height="6" rx="1.1" />
      <path d="M5.4 7.6V10M5.4 16v2.4" />
      <rect x="10" y="5.6" width="4" height="7" rx="1.1" />
      <path d="M12 3.2v2.4M12 12.6v2.6" />
      <rect x="16.6" y="9" width="4" height="6.4" rx="1.1" />
      <path d="M18.6 6.6V9M18.6 15.4v2.6" />
    </svg>
  );
}

/** Terminal — линия цены со стрелкой вверх: ручная торговля на живом графике. */
export function TerminalIcon({ active }: { active: boolean }) {
  return (
    <svg {...frame(active)}>
      <path d="M3.5 20.2h17" />
      <path d="m4 15.4 4.6-5 3.6 3.2 7-8" />
      <path d="M14.8 5.4h4.6V10" />
    </svg>
  );
}

/** Tokens — огранённый кристалл, как токены 💎 в текстах. */
export function TokensIcon({ active }: { active: boolean }) {
  return (
    <svg {...frame(active)}>
      <path d="M7.2 4h9.6l3.7 5.2L12 20.4 3.5 9.2 7.2 4Z" />
      <path d="M3.5 9.2h17" />
      <path d="m7.2 4 2.5 5.2 2.3 11.2 2.3-11.2L16.8 4" />
    </svg>
  );
}

export function AccountIcon({ active }: { active: boolean }) {
  return (
    <svg {...frame(active)}>
      <circle cx="12" cy="7.8" r="3.5" />
      <path d="M5.4 20.2a6.6 6.6 0 0 1 13.2 0" />
    </svg>
  );
}
